import { parseSpaConfig } from '@ori-appshell/config';
import { ThemeProvider } from '@ori-ui/mui';
import { AuthorizationCodeTokenClient, IDENTITY_CLIENT_ID, OidcUrlHelper, UniversalTokenProvider } from '@ori/auth';

import { App } from './App';
import { APP_NAME } from './constants';
import { ErrorBoundary } from './containers';
import type { AppConfiguration } from './models';

export async function render(rootElement: HTMLElement) {
  // Handle iframe redirect stop app after getting auth code to not duplicate itself as we can't use router
  const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);

  const { config = '' } = rootElement.dataset;
  const appConfig = parseSpaConfig<AppConfiguration>(config, []);
  const { customerId, identityUrl } = appConfig;

  // extract token from URL; only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== 'production' && searchParams.has('state')) {
    const oidcUrlHelper = new OidcUrlHelper();

    const tokenClient = new AuthorizationCodeTokenClient({
      clientId: IDENTITY_CLIENT_ID,
      identityUrl,
    });
    oidcUrlHelper.storeAuthCodeFromParams(searchParams);
    await tokenClient.initializeTokenFromAuthorizationCode();
    oidcUrlHelper.handleRedirectAfterLogin();
  }

  const { createRoot } = await import('react-dom/client');
  createRoot(rootElement).render(
    <ErrorBoundary>
      <UniversalTokenProvider
        customerId={customerId}
        initialToken=""
      >
        <ThemeProvider
          enableCacheProvider
          cacheKey={APP_NAME}
        >
          <App configuration={appConfig} />
        </ThemeProvider>
      </UniversalTokenProvider>
    </ErrorBoundary>,
  );
}
